import { useState } from 'react';

const useSort = () => {
  const [showFilters, setShowFilters] = useState(true);

  function toggle() {
    setShowFilters(!showFilters);
  }

  return {
    showFilters,
    toggle
  };
};

export default useSort;
